// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__fE6wB","fade_in":"Logo_fade_in__UxoYh","dilate_outer":"Logo_dilate_outer__IMKXq","dilate_inner":"Logo_dilate_inner__gHPYp"};